export const promocodeSuccess = 'Промокод активирован!';
export const promocodeError = 'Промокод не найден';
